import GenericModel from '../generic-model';
import Company from './company';

export default class PMSColor extends GenericModel {
  name?: string;
  company?: Company;
  archived?: boolean;

  constructor() {
    super();
  }
}
